"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUniqueIdWithPrefix = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var counter = 0;

/**
 * Unique ID generator for components
 * @param prefix
 */
var useUniqueIdWithPrefix = function useUniqueIdWithPrefix(prefix) {
  var _useState = (0, _react.useState)(function () {
      return counter++;
    }),
    _useState2 = (0, _slicedToArray2.default)(_useState, 1),
    count = _useState2[0];
  return "".concat(prefix, "-").concat(count);
};
exports.useUniqueIdWithPrefix = useUniqueIdWithPrefix;